var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row align-center"},[_c('div',{staticClass:"mr-2",staticStyle:{"max-width":"280px","width":"15vw"}},[_c('search-field',{attrs:{"name":_vm.name,"autocomplete":_vm.autocomplete,"role":_vm.role}})],1),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }